import React from "react";
import { Routes, Route } from "react-router-dom";
import CustomFields from "./CustomFields";
import Landing from "./Landing";
import ContactPanelSettingsPanel from "@/pages/Messaging/Settings/ContactPanel";
import ContactsList from "./Contacts";
import ContactDetail from "./Contacts/ContactDetail";

export default function ContactCenter() {
  return (
    <div className="flex h-full">
      <div className="w-full">
        <Routes>
          <Route path="contacts" element={<ContactsList />} />
          <Route path="contacts/:id" element={<ContactDetail />} />
          <Route path="custom_fields" element={<CustomFields />} />
          <Route path="contact-panel" element={<ContactPanelSettingsPanel />} />
          <Route path="*" element={<Landing />} />
        </Routes>
      </div>
    </div>
  );
}
